import React, { useEffect, useState } from 'react';
import Header from './components/header';
import Footer from './components/footer';
import ScrollTopWrapper from './components/scrollToTopWrapper';
import { fetchBranchBySlug } from '../services/branchs.service';
import Branch from '../models/branch.model';


const Layout: React.FC = props => {

  const { children } = props;

  const [branch, setBranch] = useState<Branch | undefined>(undefined);

  const init = async () => {
    const branch = await fetchBranchBySlug('head-office');
    setBranch(branch);
  }
  useEffect(() => {
    init();
  }, []); //eslint-disable-line


  return (
    <ScrollTopWrapper>
      <Header branch={branch} />
      <div style={{ minHeight: '70vh' }}>
        {children}
      </div>
      <Footer branch={branch} />
    </ScrollTopWrapper>
  );
}

export default Layout;